import HeaderNav from "components/FutureNavBasedComponents/HeaderNav";
import UnderHeaderSection from "components/FutureNavBasedComponents/PageSubheader/UnderHeaderSection";
import PdfViewerMUI from "components/FutureNavBasedComponents/PdfViewer/PdfViewer";
import PillButton from "components/FutureNavBasedComponents/PillButton";
import TwoPanelView from "components/FutureNavBasedComponents/TwoPanelView";
import RightInfoPanel from "../ArtifactInfopanels/RightInfoPanel";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { setArtifactDetailsRedux } from "redux/slices/artifactDetails/artifactDetailsSlice";
import { AISelectedArea, setArtifactAISkillSelectionsRedux, clearArtifactAISkillSelections } from "redux/slices/artifactAISkillSelections/artifactAISkillSelections";
import educatorService from "services/educatorService";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import useAIHelperNavigation from "../../../hooks/useAIHelperNavigation";
import useFormattedUserName from "./hooks/useFormattedUserName";

const AIHelperGetStarted = () => {
  const location = useLocation();
  const { handleBackToList, handleGoToSkillsReview } = useAIHelperNavigation();
  const { artifactId, skillsData, name } = location.state || {};
  const { firstName, userName } = useFormattedUserName();
  const dispatch = useDispatch();

  const artifactDetails = useSelector((state: any) => state.artifactDetails?.data);
  const handleGetStarted = handleGoToSkillsReview;

  useEffect(() => {
    const fetchData = async () => {
      if(artifactId>0){
        const data = await educatorService.getEvidenceDetails(artifactId);
        dispatch(setArtifactDetailsRedux({
          ...artifactDetails,
          ...data
        }));

        const AISummary = data.ai_summary;

        if (AISummary) {
          const AISkillSelections: AISelectedArea[] = AISummary.skills;

          if (AISkillSelections) {
            dispatch(setArtifactAISkillSelectionsRedux(AISkillSelections as AISelectedArea[]));
          }
        } else {
          // New artifact has no AI summary — clear stale data from previous artifact
          dispatch(clearArtifactAISkillSelections());
        }
      }
    };

    fetchData();
  }, [artifactId]);

  return (
    <div className="tailwind-page font-beausite text-typography-charcoal pb-5">
      <div className="max-w-screen mx-[13px]">
        <HeaderNav />
      </div>

      <div className="flex justify-between">
        <UnderHeaderSection
          backButtonLabel="Learner Artifacts List"
          onBackButtonClick={() => {handleBackToList()}}
          pageMainHeader="Review Artifact & Leave Feedback"
          pageSubheader={<><p className="text-base">Select <b>Get Started</b> to use the AI assistant to draft feedback for {firstName}.</p></>}
        />

        <div className="flex items-center pr-[31px]">
          <PillButton onClick={() => handleGetStarted()} label="Get Started" variant="dark" />
        </div>
      </div>
      <TwoPanelView
        leftPanelHeader={artifactDetails?.title?.length > 100 ? artifactDetails.title.slice(0, 100) + "..." : artifactDetails?.title}
        leftPanelSubheader={`Learner: ${userName}`}
        LeftPanelContent={(
          <PdfViewerMUI file={artifactDetails?.fileUrl} />
        )}
        rightPanelHeader="Artifact Details"
        RightPanelContent={(
          <RightInfoPanel artifactDetails={artifactDetails} skillsData={skillsData} userName={userName} firstName={firstName} />
        )}
      />
    </div>
  );
};

export default AIHelperGetStarted;